export default "__VITE_ASSET__BghJPmQP__"